<template>
  <!-- 基本信息组件 -->
  <div class="base-info-wrap">
    <div class="info-content">
      <el-table id="tableInfo" :data="tableData" :max-height="505" :header-cell-style="styleObj">
        <el-table-column prop="title" label="" align="center" fixed="left">
          <template slot-scope="scope">
            <div class="scope-title">
              <div>
                <span style="display:block">{{ scope.row.name }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 按照患者端记录日期进行显示，从左到右按照患者端填写置管日期从远到近（倒叙）来显示，如数据过多，则固定首次置管数据，进行滑动展示其他数据 -->
        <el-table-column :prop="item.prop" v-for="(item, index) in tableTitleList" :key="index" :label="item"
          align="center">
          <template slot-scope="scope">
            <span style="vertical-align: top;margin-right: 12px;">{{
                  scope.row[(item)]
                }}</span>
            <!-- <img style="vertical-align: middle;width: 5px;" src="../../../../assets/images/top.png"
              v-if="scope.row[(item+'status')]==1">
            <img style="vertical-align: middle;width: 5px;" src="../../../../assets/images/bottom.png"
              v-if="scope.row[(item+'status')]==-1"> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getPiccVOByPatientId } from "../../api/index";
export default {
  name: "picc",
  props: {
    userData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableTitleList: [],
      tableData: [],
      styleObj: {
        background: "#FAFAFA",
        fontWeight: "500",
        color: "#333333",
        fontSize: "14px"
      }
    };
  },
  watch: {
    "userData.patientId": {
      handler(newVal, oldVal) {
        this.getBaseInfoTableData();
      },
      deep: true
    }
  },
  created() {
    if (this.userData.patientId) {
      this.getBaseInfoTableData();
    }
  },
  methods: {
    async getBaseInfoTableData() {
      getPiccVOByPatientId(this.userData.patientId).then(result => {
        let data = result.data;
        if (result.code === 0) {
          this.tableTitleList = data.headers;
          this.tableData = data.dataList;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.base-info-wrap {
  height: 100%;
  background: #ffffff;
  .base-title {
    margin-bottom: 14px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .search-wrap {
    background-color: #ffffff;
    padding: 15px;
  }
  .info-content {
    height: calc(100% - 80px);
    // margin-top: 16px;
    padding: 17px 16px;
    background-color: #ffffff;
  }
  .btn-bg {
    background-color: #1a7bfc;
  }
  .active-bg {
    background-color: #1a7bfc;
    color: #ffffff !important;
  }
  .tab-wrap {
    padding: 10px 15px;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    // border-radius: 4px;
    li {
      padding: 5px 10px;
      color: #1a7bfc;
      border: 1px solid #1a7bfc;
    }
  }
}
/deep/.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
.noData {
  width: 106px;
  // position: absolute;
  // left: 50%;
  // top: 0;
  margin: 0 auto;
  margin-top: 100px;
  img {
    width: 100%;
    height: 99px;
  }
  span {
    width: 100%;
    display: block;
    text-align: center;
    color: #999999;
    font-size: 12px;
  }
}
.week-btn {
  color: #1a7bfc;
  border: 1px solid #1a7bfc;
}
// 重点标识
/deep/.first-column {
  .cell {
    display: flex;
    // position: relative;
    align-items: center;
    padding-left: 54px;
    padding-bottom: 3px;
    .import {
      position: absolute;
      left: 10px;
      // top: 0;
      font-size: 12px;
      height: 26px;
      color: #1a7bfc;
      background: #e9f2fe;
      border: 1px solid #95c2fc;
      border-radius: 2px;
      padding: 0 4px;
    }
  }
}
</style>
<style>
.first-column {
  background-color: rgb(250, 250, 250) !important;
}
</style>